"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var JsonToTable_1 = require("./JsonToTable");
exports.default = JsonToTable_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-json-to-table/build/lib/components/JsonToTable/index.js
// module id = 780
// module chunks = 0